import { PagePermissionEntityInterface, RoleEntityInterface } from '@types';

export type RoleState = {
  roles: RoleEntityInterface[];
  currentRolePermissions: PagePermissionEntityInterface[];
  isRolePermissionsSaving: boolean;
  roleIdForDelete: string;
  isDeletingRoleLoading: boolean;
};

export const roleInitialState: RoleState = {
  roles: [],
  currentRolePermissions: null,
  isRolePermissionsSaving: false,
  roleIdForDelete: null,
  isDeletingRoleLoading: false,
};
